import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};

  return baseSeoUtil({
    site,
    siteConf,
    title: `All Companies`,
    url: `https://www.fastcompany.com/company`,
    description: `A list of companies Fast Company has featured including the Most Innovative`,
    image: `https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png`,
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
}
